module.exports = __webpack_public_path__ + "img/recruit-lp.b655aa43.png";